const Icon = ({ type, ...props }) => (
  <span {...props}>
    <i className={`fa fa-${type}`} aria-hidden="true" />
  </span>
);

export default Icon;
